import { render, staticRenderFns } from "./SaRequiredDocInput.vue?vue&type=template&id=0e903aa6&"
import script from "./SaRequiredDocInput.vue?vue&type=script&lang=js&"
export * from "./SaRequiredDocInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports